import { FormEvent, HTMLProps, useCallback, useRef } from 'react';

type FormProps = HTMLProps<HTMLFormElement>;

export function Form({ onSubmit, ...props }: FormProps) {
  const ref = useRef<HTMLFormElement>(null);

  const handleSubmit = useCallback(
    (event: FormEvent<HTMLFormElement>) => {
      event.preventDefault();
      onSubmit?.(event);
    },
    [onSubmit],
  );

  return <form type='submit' onSubmit={handleSubmit} {...props} ref={ref} />;
}
